import words from 'lodash.words';
import upperFirst from 'lodash.upperfirst';

export default {
  unslugify(string) {
    return words(string)
      .map(word => upperFirst(word))
      .join(' ');
  },
};
